"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var tooltip_1 = __importDefault(require("relements/build/esm/overlays/tooltip"));
var InfoIconV4_1 = __importDefault(require("relements/build/esm/ui/icons/InfoIconV4"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var Label = function (_a) {
    var text = _a.text, _b = _a.marginTop, marginTop = _b === void 0 ? 0 : _b, _c = _a.marginBottom, marginBottom = _c === void 0 ? 0 : _c, _d = _a.info, info = _d === void 0 ? '' : _d, _e = _a.isError, isError = _e === void 0 ? false : _e;
    return (react_1["default"].createElement(box_1["default"], { padding: "0", alignItems: "center" },
        react_1["default"].createElement(text_1["default"], { color: isError ? 'red.haptik' : 'black.haptik', variant: "body.md", style: { marginTop: marginTop, marginBottom: marginBottom } }, text),
        react_1["default"].createElement(tooltip_1["default"], { themed: true, tooltip: info, position: "TOP" },
            react_1["default"].createElement(InfoIconV4_1["default"], { size: "small", iconColor: "grey.dark", marginLeft: "4px", marginBottom: marginBottom }))));
};
exports["default"] = Label;
